/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatRequest,
} from '../models/index';
import {
    ChatRequestFromJSON,
    ChatRequestToJSON,
} from '../models/index';

export interface ChatOperationRequest {
    chatRequest: ChatRequest;
    sessionId?: string;
}

export interface GetBudgetsRequest {
    sessionId?: string;
}

export interface GetUsage2Request {
    sessionId?: string;
    start?: string;
    end?: string;
    userId?: string;
    gatewayInstanceId?: string;
}

/**
 * LLMApi - interface
 * 
 * @export
 * @interface LLMApiInterface
 */
export interface LLMApiInterface {
    /**
     * Execute chat completion via platform LLM gateway (tenant or platform default)
     * @summary Chat completion
     * @param {ChatRequest} chatRequest 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApiInterface
     */
    chatRaw(requestParameters: ChatOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Execute chat completion via platform LLM gateway (tenant or platform default)
     * Chat completion
     */
    chat(requestParameters: ChatOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get budget config (AI_LLM_CONFIG) and current spend for tenant
     * @summary Budget config and spend
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApiInterface
     */
    getBudgetsRaw(requestParameters: GetBudgetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get budget config (AI_LLM_CONFIG) and current spend for tenant
     * Budget config and spend
     */
    getBudgets(requestParameters: GetBudgetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Query LLM usage by tenant (from context), optional date range, userId, gatewayInstanceId
     * @summary Query usage
     * @param {string} [sessionId] Session ID
     * @param {string} [start] Start time (ISO-8601 or epoch ms)
     * @param {string} [end] End time (ISO-8601 or epoch ms)
     * @param {string} [userId] Filter by user ID
     * @param {string} [gatewayInstanceId] Filter by gateway instance ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApiInterface
     */
    getUsage2Raw(requestParameters: GetUsage2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Query LLM usage by tenant (from context), optional date range, userId, gatewayInstanceId
     * Query usage
     */
    getUsage2(requestParameters: GetUsage2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class LLMApi extends runtime.BaseAPI implements LLMApiInterface {

    /**
     * Execute chat completion via platform LLM gateway (tenant or platform default)
     * Chat completion
     */
    async chatRaw(requestParameters: ChatOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chatRequest'] == null) {
            throw new runtime.RequiredError(
                'chatRequest',
                'Required parameter "chatRequest" was null or undefined when calling chat().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/llm/chat`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatRequestToJSON(requestParameters['chatRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Execute chat completion via platform LLM gateway (tenant or platform default)
     * Chat completion
     */
    async chat(requestParameters: ChatOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.chatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get budget config (AI_LLM_CONFIG) and current spend for tenant
     * Budget config and spend
     */
    async getBudgetsRaw(requestParameters: GetBudgetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/llm/budgets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get budget config (AI_LLM_CONFIG) and current spend for tenant
     * Budget config and spend
     */
    async getBudgets(requestParameters: GetBudgetsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBudgetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Query LLM usage by tenant (from context), optional date range, userId, gatewayInstanceId
     * Query usage
     */
    async getUsage2Raw(requestParameters: GetUsage2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['start'] != null) {
            queryParameters['start'] = requestParameters['start'];
        }

        if (requestParameters['end'] != null) {
            queryParameters['end'] = requestParameters['end'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['gatewayInstanceId'] != null) {
            queryParameters['gatewayInstanceId'] = requestParameters['gatewayInstanceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/llm/usage`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Query LLM usage by tenant (from context), optional date range, userId, gatewayInstanceId
     * Query usage
     */
    async getUsage2(requestParameters: GetUsage2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUsage2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
